<div id="wrapper" [class]="getMainClasses()">
  <app-header
    [versao]="versaoSistema"
    [menus]="options"
    [labelAmbiente]="labelAmbiente"
    (contrastChange)="changeContrast($event)"></app-header>
  <app-main></app-main>
  <app-loading></app-loading>
</div>
